import React from 'react';
import { Triggers } from '../components';

export default () => {
    return (
        <Triggers.Home />
    )
}